<template>
  <div class="selfTest">
    <div class="left">
      <div class="item">
        <img src="../../assets/img/icon_shu.png" />
        <div @click="$router.back()">考试库</div>
      </div>
      <div class="item" style="background: #f8fafb">
        <img src="../../assets/img/icon_shu.png" />
        <div>自测</div>
      </div>
    </div>
    <div class="right">
      <!-- 选题知识点 -->
      <el-collapse v-model="activeNames">
        <el-collapse-item title="所有章节" name="1">
          <el-button
            v-for="(item, i) in chapterList"
            :key="i"
            class="thList"
            :class="item.serialnumber == index ? 'hover' : ''"
            @click="goKnowledge(item.id)"
            >{{ item.chapter }}</el-button
          >
        </el-collapse-item>
        <!-- <el-collapse-item title="知识点" name="2">
          <el-tag
            v-for="(item, index) in knowledgeList"
            :key="index"
            :id="item.id"
            effect="plain"
            type="info"
          >
            <el-tag size="small" type="warning" effect="dark">{{
              index + 1
            }}</el-tag>
            {{ item.knowledge }}</el-tag
          >
        </el-collapse-item> -->
        <el-collapse-item title="题型选择" name="3">
          <div
            v-for="(idx, index) in knowledgeList"
            :key="index"
            :serialnumber="idx.serialnumber"
          >
            <el-checkbox-group
              v-if="checkboxShow"
              v-model="slectType[idx.id - 1].dataList"
              class="knowledgeGroup"
            >
              <el-tag type="warning" effect="dark" class="knowledgeTitle">{{
                index + 1 + idx.knowledge
              }}</el-tag>

              <el-checkbox
                v-for="(item, i) in selquestiontype[index].datas"
                :key="i"
                :label="item.subjectType"
                @change="checkOne(idx.serialnumber, item.subjectType)"
                :value="item.checked"
                :disabled="item.disabled"
                border
              >
                {{ item.type }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
        </el-collapse-item>
      </el-collapse>
      <!-- 选题知识点结束 -->
      <div class="top">
        <el-button type="primary" style="width: 120px" @click="$router.back()"
          >取消</el-button
        >
        <el-button type="primary" style="width: 120px" @click="goTestDetil"
          >测试</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { getToken } from "@/util/session";
import {
  getChapterPageList,
  mathsGetMathsPageList,
  getQuestionCountList,
  getTempQuestionList
} from "@/api/student";
import { mapState } from "vuex";
export default {
  name: "selfTest",
  data() {
    return {
      dataList: [],
      activeNames: ["1", "2", "3"], //collapse默认展开项
      chapterList: [],
      knowledgeList: [],
      show: true,
      index: "",
      typeList: [
        {
          type: "单选",
          id: "1",
          subjectType: "SingX",
          checked: false,
          disabled: true
        },
        {
          type: "多选",
          id: "2",
          subjectType: "MultX",
          checked: false,
          disabled: true
        },
        {
          type: "判断",
          id: "3",
          subjectType: "JudgX",
          checked: false,
          disabled: true
        },
        {
          type: "填空",
          id: "4",
          subjectType: "FillX",
          checked: false,
          disabled: true
        },
        {
          type: "计算",
          id: "5",
          subjectType: "AnwsX",
          checked: false,
          disabled: true
        },
        {
          type: "证明",
          id: "6",
          subjectType: "ProofX",
          checked: false,
          disabled: true
        }
      ],
      checkboxGroup: [[]],
      firstPlayFlag: true,
      selquestiontype: new Array(),
      slectType: [], //选择的题型保存是通过知识点的id去当做索引保存,v-for遍历的时候也是通过对应id去取,选中状态数据之间相互独立
      list: [],
      // qNum: [], //主观题数量
      // qNum1: [], //客观题数量
      loadquestioncount: [],
      questionData: [], //保存出题id的数据
      serialnumber: [], //知识点编号
      questionType: [], //题型
      questionArr: [], //保存选中题型的所有题目
      level: [1, 2, 3],
      checkboxShow: false
    };
  },
  computed: {
    ...mapState({
      checkListFlag: state => state.problemdata.checkListFlag
    })
  },
  mounted() {
    var coursesId = this.$route.query.coursesId;
    const that = this;
    let token = getToken();
    //获取所有章节
    getChapterPageList({
      token,
      coursesId
    })
      .then(res => {
        that.chapterList = res.data;
        console.log(that.chapterList);
        that.chapterList.sort((a, b) => {
          return a.id - b.id;
        });
        console.log(that.chapterList);
        // console.log("that.chapterList", that.chapterList);
      })
      .catch(err => {
        console.log(err);
      });

    that.checkboxGroup = this.checkListFlag;
  },
  //监控data中的数据变化
  methods: {
    //选中数据,拿到选择的知识点编号以及题型
    checkOne(num, qtype) {
      this.serialnumber.push(num);
      this.serialnumber = [...new Set(this.serialnumber)];
      this.questionType.push(qtype);
      this.questionType = [...new Set(this.questionType)];
    },
    //选择知识点
    goKnowledge(chapterID) {
      this.checkboxShow = false; //再次触发,有清除之前checkboxgroup的状态
      this.index = chapterID;
      const coursesId = this.$route.query.coursesId;
      let token = getToken();
      // console.log("chapterID", chapterID, "coursesId", coursesId);
      //获取所有知识点
      mathsGetMathsPageList({
        token,
        chapterID,
        coursesId
      })
        .then(async res => {
          //保存知识点
          this.knowledgeList = res.data;
          this.knowledgeList.sort((a, b) => {
            return a.id - b.id;
          });
          // console.log("res1", res);
          //筛选出知识点对应的id,数组
          let arr = this.knowledgeList.map(item => {
            return item.serialnumber;
          });
          // console.log("arr", arr);
          //请求知识点所对应的题型信息
          const examquestionquery = await getQuestionCountList({
            courseSerialnumber: this.$route.query.serialNumber, //所选课程的id
            knowledgeSerialnumbers: arr
          });
          //存储返回数据
          console.log(examquestionquery);
          this.loadquestioncount = examquestionquery.data;
          let knowledgeLength = this.knowledgeList.length;
          //遍历筛选
          for (let i = 0; i < knowledgeLength; i++) {
            let tmpknowledge = this.knowledgeList[i];
            let fid = this.selquestiontype.findIndex(
              x => x.serialnumber === tmpknowledge.serialnumber
            );
            console.log(fid);
            if (fid == -1) {
              //定义一个对象存放数据
              let tmpseldata = {
                serialnumber: tmpknowledge.serialnumber,
                datas: JSON.parse(JSON.stringify(this.typeList)), // 深拷贝，避免所有知识点共享同一个引用
                dataList: []
              };
              console.log(tmpseldata);
              //过滤掉返回的数据中knowledgeID和knowledgeList里面的serialnumber相同的
              console.log(this.loadquestioncount);
              let fltarr = this.loadquestioncount.filter(
                x => x.knowledgeID === tmpknowledge.serialnumber
              );
              tmpseldata.datas[0].disabled =
                fltarr.findIndex(x => x.qType === "SingX") == -1;
              tmpseldata.datas[1].disabled =
                fltarr.findIndex(x => x.qType === "MultX") == -1;
              tmpseldata.datas[2].disabled =
                fltarr.findIndex(x => x.qType === "JudgX") == -1;
              tmpseldata.datas[3].disabled =
                fltarr.findIndex(x => x.qType === "FillX") == -1;
              tmpseldata.datas[4].disabled =
                fltarr.findIndex(x => x.qType === "AnwsX") == -1;
              tmpseldata.datas[5].disabled =
                fltarr.findIndex(x => x.qType === "ProofX") == -1;
              this.selquestiontype.push(tmpseldata);

              //把知识点id当做索引去保存数据
              this.slectType[tmpknowledge.id - 1] = tmpseldata;
              console.log(this.slectType);
            } else {
              let fltarr = this.loadquestioncount.filter(
                x => x.knowledgeID === tmpknowledge.serialnumber
              );
              let tmpseldata = this.selquestiontype[fid];
              console.log(tmpseldata);
              tmpseldata.datas[0].disabled =
                fltarr.findIndex(x => x.qType === "SingX") == -1;
              tmpseldata.datas[1].disabled =
                fltarr.findIndex(x => x.qType === "MultX") == -1;
              tmpseldata.datas[2].disabled =
                fltarr.findIndex(x => x.qType === "JudgX") == -1;
              tmpseldata.datas[3].disabled =
                fltarr.findIndex(x => x.qType === "FillX") == -1;
              tmpseldata.datas[4].disabled =
                fltarr.findIndex(x => x.qType === "AnwsX") == -1;
              tmpseldata.datas[5].disabled =
                fltarr.findIndex(x => x.qType === "ProofX") == -1;
            }
            console.log(this.selquestiontype);
          }
          //在执行完毕之后,说明dataList里面才有数据,此时才显示checkboxgroup,就不会报错
          this.checkboxShow = true;
          // that.checkboxGroup = new Array(res.data.length).fill([]); // 有多少个知识点,就创建多少个空数组
        })
        .catch(err => {
          console.log(err);
        });
    },
    //测试
    async goTestDetil() {
      const selectedKnowledgeSet = new Set();
      const selectedTypeSet = new Set();
      this.knowledgeList.forEach(item => {
        const selected = this.slectType[item.id - 1];
        if (!selected || !Array.isArray(selected.dataList)) {
          return;
        }
        if (selected.dataList.length > 0) {
          selectedKnowledgeSet.add(selected.serialnumber);
          selected.dataList.forEach(type => selectedTypeSet.add(type));
        }
      });

      const selectedKnowledge = [...selectedKnowledgeSet];
      const selectedTypes = [...selectedTypeSet];
      const targetNum = parseInt(this.$route.query.num, 10);

      if (selectedKnowledge.length === 0) {
        this.$message(
          "Please select knowledge points and question types first"
        );
        return;
      }
      if (selectedTypes.length === 0) {
        this.$message("Please select question types first");
        return;
      }
      if (!Number.isInteger(targetNum) || targetNum <= 0) {
        this.$message("Invalid question count");
        return;
      }

      this.serialnumber = selectedKnowledge;
      this.questionType = selectedTypes;
      this.questionData = [];
      this.questionArr = [];

      const result = await getTempQuestionList({
        courseSerialnumber: this.$route.query.serialNumber,
        knowledgeSerialnumbers: selectedKnowledge
      });
      const pool = Array.isArray(result.data) ? result.data : [];
      const selectedTypeLookup = new Set(selectedTypes);
      const levelLookup = new Set(this.level);

      const buckets = {};
      selectedTypes.forEach(type => {
        buckets[type] = [];
      });

      pool.forEach(item => {
        if (!item || !selectedTypeLookup.has(item.qtype)) {
          return;
        }
        if (!levelLookup.has(Number(item.level))) {
          return;
        }
        buckets[item.qtype].push(item.id);
      });

      selectedTypes.forEach(type => {
        buckets[type] = [...new Set(buckets[type])];
      });

      const totalAvailable = selectedTypes.reduce(
        (sum, type) => sum + buckets[type].length,
        0
      );
      if (totalAvailable < targetNum) {
        this.$message(
          `Available questions are insufficient. Max: ${totalAvailable}`
        );
        return;
      }

      const selectedIds = [];
      const selectedIdSet = new Set();
      const baseCount = Math.floor(targetNum / selectedTypes.length);
      const extraCount = targetNum % selectedTypes.length;

      selectedTypes.forEach((type, index) => {
        const needCount = baseCount + (index < extraCount ? 1 : 0);
        const picked = this.getRandomArray(buckets[type], needCount);
        picked.forEach(id => {
          if (!selectedIdSet.has(id)) {
            selectedIdSet.add(id);
            selectedIds.push(id);
          }
        });
      });

      if (selectedIds.length < targetNum) {
        const restPool = [];
        selectedTypes.forEach(type => {
          buckets[type].forEach(id => {
            if (!selectedIdSet.has(id)) {
              restPool.push(id);
            }
          });
        });
        const restPicked = this.getRandomArray(
          [...new Set(restPool)],
          targetNum - selectedIds.length
        );
        restPicked.forEach(id => {
          if (!selectedIdSet.has(id)) {
            selectedIdSet.add(id);
            selectedIds.push(id);
          }
        });
      }

      this.questionData = selectedIds.slice(0, targetNum);
      this.show = 1;
      this.$router.push({
        path: "/home/test-detail",
        query: {
          questionIdArr: this.questionData,
          catalog: this.$route.query.catalog,
          coursesId: this.$route.query.coursesId,
          show: this.show
        }
      });
    },
    //随机获取[min,max]的随机整数
    getRandomNum(min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min);
    },
    //从数组arr中，随机取nCount个元素，返回数组。可选择是否去重
    getRandomArray(arr, count, qc = 1) {
      if (!(arr instanceof Array)) {
        return [];
      }
      let length = arr.length;
      let arrRes = [];
      count = length < count ? length : count;
      console.log(count);
      console.log();
      while (arrRes.length < count) {
        let randomIndex = this.getRandomNum(0, length - 1);
        let item = arr[randomIndex];
        if (item) {
          if (qc) {
            if (arrRes.indexOf(item) < 0) {
              arrRes.push(item);
            }
          } else {
            arrRes.push(item);
          }
        }
      }
      return arrRes;
    }
  }
};
</script>
<style lang="scss" scoped>
.selfTest {
  display: flex;
  .left {
    width: 242px;
    .item {
      display: flex;
      padding: 20px 30px;
      cursor: pointer;
      img {
        width: 20px;
        margin-right: 15px;
      }
    }
  }
  .right {
    flex-grow: 1;
    padding: 28px;
    height: 100%;
    background: #f8fafb;
    table {
      width: 100%;
      height: 100%;
      background: #fff;
      margin: auto;
      tr {
        width: 100%;
        height: 50px;
        background: #f8f8ff;
        margin-bottom: 20px;
        .on {
          background: #dcdcdc;
        }
        .up {
          background: #f8f8ff;
        }
      }
    }
    .thList.hover {
      border: 1px solid #000000;
    }
  }
  .top {
    width: 100%;
    height: 50px;
    margin-top: 4%;
  }
}
.knowledgeTitle {
  width: 400px;
  text-align: left;
  overflow-x: clip;
}
.knowledgeGroup {
  margin: 10px 0;
  left: 25px;
  position: relative;
  display: flex;
}
::v-deep .el-collapse-item__header {
  font-size: 14px;
  font-weight: bold;
  padding-left: 10px;
}
::v-deep .el-tag {
  font-size: 14px;
  margin-right: 10px;
}
</style>
